import { Row, Col, Modal } from 'react-bootstrap';
import { Input, PackagesInput } from '../../Input/Input';
import React, { useContext, useState, useEffect } from 'react';
import { StoreContext } from '../../Store';
import fileLoaderSvg from '../../../images/file_upload.svg';
import { numberWithCommas } from '../../../utils/format';
// '../../images/information.svg'

const PackageModal = ({ show, onHide, onContinue }) => {
  // const { localData, setDataByKey, unvisitStep } = useStepper();
  const store = useContext(StoreContext);

  function cancelClick() {
    onHide();
    store.customPackageTotal[1](0);
  }

  // async function continueClick() {
  //   onHide();

  // }

  return (
    <Modal show={show} centered size={'md'} onHide={onHide} animation={false}>
      <Modal.Header>
        <Modal.Title className="d-flex gap-3 align-items-center py-2">
          <div className="warning" /> <span>Overwrite total number of packages</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-4 py-4">
        <>
          <p className="bold">
            Warning - the value entered below will overwrite the total number of packages for this load
          </p>
          <Input
            label="Custom Number of Packages"
            numeric={true}
            value={store.customPackageTotal[0]}
            onChange={(e) => store.customPackageTotal[1](e.target.value)}
          />
        </>
      </Modal.Body>
      <Modal.Footer
        class="d-flex flex-row py-4 px-3 gap-3 border-top bg-light justify-content-between align-items-center"
        style={{
          borderBottomLeftRadius: '20px',
          borderBottomRightRadius: '20px',
        }}
      >
        <button class="stepper-button" onClick={cancelClick}>
          Cancel
        </button>

        <button class="stepper-button yellow" onClick={() => onContinue()}>
          Confirm
        </button>
      </Modal.Footer>
    </Modal>
  );
};

const RenderTotalColumn = ({ field, label, value, className = '' }) => {
  return field !== undefined ? (
    <Col>
      <Input disabled label={label} value={value} classNameInputField={className} />
    </Col>
  ) : null;
};

const RenderTotalColumnWithChildren = ({ field, children }) => {
  return field !== undefined ? <>{children}</> : null;
};

function GridTotalsPI({ grossKG, netKG, itemCount, value, rows, itemHeaders, billableType, readOnly }) {
  const store = useContext(StoreContext);
  const [showPackageModal, setShowPackageModal] = useState(false);

  const grossKGformatted = numberWithCommas(grossKG, true);
  const netKGformatted = numberWithCommas(netKG, true);
  const itemCountformatted = numberWithCommas(itemCount, false);
  const valueFormatted = numberWithCommas(value, true);

  // const [packageText, setPackageText] = useState(itemCountformatted)

  useEffect(() => {
    //   setPackageText(itemCountformatted)
    store.packageTotal[1](itemCountformatted);
  }, [itemCount]);

  return (
    <div className="d-flex flex-column" style={{ marginTop: '2rem', marginBottom: '1rem' }}>
      <PackageModal
        show={showPackageModal}
        onHide={() => {
          setShowPackageModal(false);
        }}
        onContinue={() => {
          store.packageTotal[1](store.customPackageTotal[0]);
          setShowPackageModal(false);
        }}
      ></PackageModal>
      <Row>
        <RenderTotalColumn field={grossKG} label="Gross Mass (kg)" value={grossKGformatted} />
        <RenderTotalColumn field={netKG} label="Net Mass (kg)" value={netKGformatted} />
        <RenderTotalColumnWithChildren field={itemCount} label="Number of Packages">
          <Col>
            <PackagesInput
              readOnly={readOnly}
              label="Number of Packages"
              value={store.packageTotal[0]}
              onChange={(e) => store.packageTotal[1](e.target.value)}
              showPackageModal={() => {
                setShowPackageModal(true);
              }}
            />
          </Col>
        </RenderTotalColumnWithChildren>
        {/* {itemCount !== undefined && (
          
        )} */}

        <RenderTotalColumn field={value} label="Value" value={valueFormatted} />
        <RenderTotalColumn
          field={rows}
          label="Item Rows"
          value={rows}
          className={billableType == 20 && 'billable-type-textbox'}
        />
        <RenderTotalColumn
          field={itemHeaders}
          label="Item Headers"
          value={itemHeaders}
          className={billableType == 10 && 'billable-type-textbox'}
        />
      </Row>
    </div>
  );
}

export default GridTotalsPI;
